import { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { prepareGreeting, playPrepared, speakGreeting, warmGreeting } from "../../utils/speakGreeting";

// تحية صباحية شخصية: تُهيّأ داخل نقرة المستخدم وتُشغَّل بعد نجاح الحضور (سياسة iOS).
export const useGreeting = () => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const pending = useRef(null);
  const userId = user?.id;

  // تسخين الكاش مبكراً حتى تُسمع التحية في أول حضور على جهاز جديد (شرط iOS).
  useEffect(() => {
    if (userId) warmGreeting(userId);
  }, [userId]);

  const prepare = useCallback(() => {
    pending.current = userId ? prepareGreeting(userId) : null;
  }, [userId]);

  const play = useCallback(async () => {
    if (!userId) return;
    try {
      if (pending.current) {
        await playPrepared(pending.current);
        pending.current = null;
        return;
      }
      const played = await speakGreeting(userId, i18n.language === "en" ? "en" : "ar");
      if (!played) await warmGreeting(userId);
    } catch {
      /* التحية أفضل جهد فقط ولا تؤثر على الحضور */
    }
  }, [userId, i18n.language]);

  return { prepare, play };
};
